import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Text, TextType } from 'ui-components/components/text';

import DataDrivenLogo from '../../../components/data-driven-logo';
import Global from '../../../store/global-selectors';
import OrderNumber from '../order-number';

import style from './order-details-nav-bar.module.less';

export const OrderInfo = ({ storeGuid, orderNumber }) => {
  const storeData = useSelector((state) => Global.selectSellerStoreData(state, { storeGuid }));

  return (
    <>
      {!!storeData && (
        <>
          <div className={style['order-info-store-logo']}>
            <DataDrivenLogo
              className={style['marketplace-icon']}
              logoType='icon'
              marketplaceId={Number.parseInt(storeData?.marketplaceId, 10)}
            />
          </div>
          <div className={style['order-info-store-name']}>
            <Text textType={TextType.H4} value={`${storeData?.name}:`} />
          </div>
        </>
      )}
      {!!orderNumber && (
        <div className={style['order-info-order-number']}>
          <OrderNumber orderNumber={orderNumber} textType={TextType.H4} />
        </div>
      )}
    </>
  );
};

OrderInfo.propTypes = {
  storeGuid: PropTypes.string,
  orderNumber: PropTypes.string,
};
